export const EDIT_PERFECT_LIFE_PLAN = 'EDIT_PERFECT_LIFE_PLAN'

export const editPerfectLifePlan = (displayProducts) => ({
  type: EDIT_PERFECT_LIFE_PLAN,
  payload: displayProducts,
})
